import React from 'react';
import WebpackerReact from 'webpacker-react';
import FormatCalendarView from '../components/formatos/Calendar/FormatCalendar';

function FormatCalendar(props) {
    return <FormatCalendarView {...props} />;
}

export default FormatCalendar;
WebpackerReact.setup({ FormatCalendar });
